import dayjs from 'dayjs'

export const getDayOrNight = () => {
  const NOW = dayjs().hour()
  const Day = {
    EARLY_MORNING: {value: [4, 5], name: '清晨'},
    MORNING: {value: [6, 7], name: '早晨'},
    FORENOON: {value: [8, 9, 10], name: '上午'},
    NOON: {value: [11, 12, 13], name: '中午'},
    AFTERNOON: {value: [14, 15, 16, 17], name: '下午'},
    NIGHT: {value: [18, 19, 20, 21, 22, 23, 24, 0, 1, 2, 3], name: '晚上'}
  }
  let dayKeyArray = Object.keys(Day)
  let responseDay = ''
  dayKeyArray.forEach(item => {
    if(Day[item].value.indexOf(NOW) !== -1) {
      responseDay = Day[item].name
    }
  })
  return responseDay
}
/*
* 格式化日期，如果是今天，则只显示时间，否则显示日期。
* */
export const getCurrentDate = (date = new Date()) => {
    return dayjs(date).format('YYYY-MM-DD HH:mm')
}
/*
* 转化成ISO 8601格式日期 2019-01-25T02:00:00.000Z
* */
export const getDateISO = () => {
  // console.log(dayjs('2022-04-06T08:49:48.584Z').format('YYYY-MM-DDTHH:mm:ss'))
  // console.log(dayjs('2022-04-06T16:50:10.960').format('YYYY-MM-DDTHH:mm:ss'))
  return dayjs().toISOString()
}

export const getOverDateISO = (date = new Date(), overTimeMinute = 2) => {
  return dayjs(date).add(overTimeMinute, 'm').toISOString()
}

/*
* 获取时间戳(秒)
* */
export const getTimestamp = (date = new Date()) => {
  return dayjs(date).unix()
}